import { ValidationStateMap } from "./../interfaces/field/index";
import { InjectionKey, Ref } from "vue";

export default Symbol() as InjectionKey<Ref<ValidationStateMap>>;
